<template>
	<el-dialog
		title="删除记录"
		:visible.sync="isShow"
		 width='80%'
		:show-close="true"
		:close-on-click-modal="false"
		class="default-dialog deleteDataDialog">
		<div class='dateRange'>
			 <el-select
	            placeholder="请选择" size="small"  @change="getData_del"
	            v-model="form.fkJournalAccountId" clearable filterable
	             style="width:188px;margin-right: 10px;"
	          >
	            <el-option v-for="(item,index) in del_useList" :key="index" :label="item.name" :value="item.id"></el-option>
	          </el-select>
			<el-date-picker
            v-model="dateLists"
            type="monthrange"
            range-separator="至"
            size='small'
            style="width:260px"
            @change='handleDateListChange'
            value-format="yyyyMM" format="yyyy年MM期"
            start-placeholder="开始月份"
            end-placeholder="结束月份">
          </el-date-picker>
         <!--  <span class='hit'>仅保留一年以内的删除记录</span> -->
		</div>
		<!-- 表格 -->
		<public-table :table="tableData" >
			<template v-for="(k,indexx) in imgListTitle"  :slot='k' slot-scope='props'>
				<div class='images' :key='indexx'>
		  			<el-image
		  				v-for='(d,index9) in props.scope.row[k]'
		  				:key='index9'
						class='images-item'
					    :src="d.url"
					    :preview-src-list="[d.url]">
					</el-image>
		  		</div>
			</template>
		</public-table>

	</el-dialog>
</template>

<script>
import publicTable from '@/components/publicTable'

export default {
	props: {
		recycleBinVisible: Boolean,
		dateList:Array,
		del_useList:Array
	},
	components: {
		publicTable
	},
	data () {
		return {
			imgListTitle:[],  //图片数组
			dateLists:[],
			tableData: {
				Maxheight: 400,				// 限定高度
				isNotSuspensionShow: true,  // 不显示悬浮效果
				border: true,				// 是否带有纵向边框
				stripe: true,				// 是否带有斑马纹
				loading: false,				// 是否显示加载动画
				hasSelect: false,			// 是否显示多选
				hasOperation: false,			// 是否有操作功能
				hasContextmenu: false,		// 是否有右键功能
				hasShowSummary: false,		// 是否显示合计行
				hasShowPagination: false,	// 是否显示分页
				config: [],
				data: [],

				page: {
					pageNo: 1,
					pageSize: 20,
					count: 10
				},
				center: {
					textAlign: 'center'
				}
			},
			form:{
				start:"",
				end:"",
				fkJournalAccountId:""
			}

		}
	},
	created () {

	},
	mounted() {

	},
	computed: {
		isShow: {
			get () {
				return this.recycleBinVisible;
			},
			set (val) {
				this.$emit('update:recycleBinVisible', val);
			}
		},

	},
	methods: {
		// 账户切换
		getData_del(val) {
			this.getDeleteDataH();
		},
		// 日期切换
		handleDateListChange(val) {
      if(val&&val.length) {
        this.form.start = val[0];
        this.form.end = val[1];
      }else {
        this.form.start = "";
        this.form.end = "";
      }

			this.getDeleteDataH();
		},
		// 获取删除数据
		getDeleteData() {
			this.$http.post('journal/getDeleteJournal',this.form).then(res=>{
				this.tableData.loading = false;
				if(res.data&&res.data.code==1) {
					this.tableData.data = res.data.data;
				}
			})
		},
		// 获取删除啊数据表头
		getDeleteDataH() {
			this.tableData.loading = true;
			this.$http.post('journal/getUpdateJournalTitle',{type:"2"}).then(res=>{
				if(res.data&&res.data.code==1) {

					this.getDeleteData();
					this.imgListTitle=[];
					this.tableData.config = res.data.data.map((i)=>{
            i.width = 160;
						if(i.customType==5) {
								i.show='template';
								this.imgListTitle.push(i.value);
							}else {
								i.show='normal';
							}
						i.label = i.columnName;
						return i;
					})
				}else {
					this.tableData.loading = false;
				}
			})
		}

	},
	watch:{
		recycleBinVisible(val) {
			if(val) {
				this.dateLists = this.dateList;
				this.form.start = this.dateList[0];
				this.form.end = this.dateList[1];
				this.getDeleteDataH();
			}
		}
	}
}
</script>
<style lang=less>
	.deleteDataDialog {
		.dateRange {
			padding-bottom: 20px;
			line-height: 32px;
			.hit {
				color: #999;
				font-size: 12px;
				margin-left: 10px;
			}
		}
		.images {
			width: 100%;
			display: inline-block;
			&-item {
				width: 30px;
				height:30px;
				display: block;
				margin: 0 auto 10px;
			}
		}
	}

</style>



// WEBPACK FOOTER //
// src/components/dialog/recycleBin.vue